import _ from 'underscore';
import { ProjectionGridBaseColumn } from '@bingads-webui/projection-grid-base-column';
import { formatCost, getIncreaseSymbol, isPositive, ESTIMATE_TYPES } from '@bingads-webui-campaign/recommendation-core';

import template from './delta.pug';

export class CPADeltaColumn extends ProjectionGridBaseColumn {
  constructor({ i18n, isOptimizationScoreOn }) {
    const title = i18n.getString('Details_View_Est_CPA');

    super({
      name: 'CPADelta',
      property: 'EstimatedIncreaseInCpa',
      title,
      bodyClasses: ['grid-column-CPAIncrease'],
      colClasses: ['col-numberEst'],
      sortable: true,
      helpId: 'Pop_BA_Recommendations_EstChangeCPA',
      type: 'number',
      helpAriaLabel: i18n.getString('Click to learn more about {{item}}', { item: title }),
    });
    this.i18n = i18n;
    this.isOptimizationScoreOn = isOptimizationScoreOn;
  }

  template({ value: { EstimatedIncreaseInCpa, CurrentCpa } }) {
    const { i18n, isOptimizationScoreOn } = this;
    if (!_.isNumber(EstimatedIncreaseInCpa) || !_.isNumber(CurrentCpa)) {
      return template({
        i18n,
        isNegative: true,
        notAvailable: true,
        isOptimizationScoreOn,
      });
    }
    return template({
      deltaVal: formatCost(EstimatedIncreaseInCpa, i18n, i18n.currency),
      fromVal: formatCost(CurrentCpa, i18n, i18n.currency),
      toVal: formatCost(CurrentCpa + EstimatedIncreaseInCpa, i18n, i18n.currency),
      i18n,
      increaseSymbol: getIncreaseSymbol(EstimatedIncreaseInCpa),
      isNegative: !isPositive(EstimatedIncreaseInCpa, ESTIMATE_TYPES.COST),
      isOptimizationScoreOn,
    });
  }

  get property() {
    return {
      get: _.identity,
      key: 'EstimatedIncreaseInCpa',
    };
  }
}
